module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("G2eyu"))).then(() => parcelRequire('fThBo'));